/**
 * Политика хранения.
 *
 * Зеркалит правило порогов: флот может хранить ДОЛЬШЕ требования закона,
 * но не короче. Слишком короткий срок означал бы, что система сама уничтожает
 * доказательства, которые обязана предъявить при проверке.
 *
 * Удаление по истечении срока — легитимная, санкционированная и записанная
 * в журнал операция, а не тихая правка. Юридическая блокировка отменяет её
 * безусловно: истёкший срок хранения не отменяет разбирательство.
 */
import { z } from 'zod';
export const RETENTION_SUBJECTS = ['inspections', 'missed_inspections', 'notifications'];
/**
 * Законные минимумы. Для осмотров — 49 CFR 396.11(d): отчёты о состоянии
 * транспортного средства хранятся не менее трёх месяцев.
 */
export const RETENTION_FLOORS = {
    inspections: {
        subject: 'inspections',
        minDays: 90,
        label: 'Inspection records',
        citation: '49 CFR 396.11(d)',
    },
    missed_inspections: {
        subject: 'missed_inspections',
        minDays: 90,
        label: 'Missed-inspection log',
        // Отдельной нормы нет, но пропуск бессмысленно хранить короче осмотра:
        // вместе они образуют полную картину, а по отдельности вводят в заблуждение.
        citation: null,
    },
    notifications: {
        subject: 'notifications',
        minDays: 30,
        label: 'Notifications',
        citation: null,
    },
};
export const MAX_RETENTION_DAYS = 3650;
export const retentionRuleSchema = z.object({
    subject: z.enum(RETENTION_SUBJECTS),
    days: z.number().int().min(1).max(MAX_RETENTION_DAYS),
});
export function isRetentionLegal(subject, days) {
    return days >= RETENTION_FLOORS[subject].minDays;
}
export const purgeRequestSchema = z.object({
    /**
     * Обязательный флаг. Разрушающая операция не должна запускаться
     * той же формой, что и предварительный просмотр.
     */
    confirm: z.literal(true),
    reason: z.string().min(10).max(1000),
});
//# sourceMappingURL=retention.js.map